module.exports = __webpack_public_path__ + "static/media/ic_paboi2.0e2e20ef.png";